export default __webpack_public_path__ + "static/media/tag-red.b4624e51.svg";